import React from "react";
import { Dialog, DialogContent, makeStyles } from "@material-ui/core";
import ReviewComponent from "../../Review/ReviewComponent";
import { connect } from "react-redux";
import actions from "../../../redux/actions";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    padding: 48,
    overflowX: "hidden",
    borderRadius: "2rem",
  },
  paper: {
    borderRadius: "1rem",
    width: "100%",
  },
  max: {
    width: "100%",
    alignItems: "center",
  },
}));

function ReviewModal(props) {
  const classes = useStyles();
  const { isOpen, resetModal } = props;
  return (
    <Dialog
      open={isOpen}
      maxWidth="xs"
      onClose={resetModal}
      className={classes.max}
      classes={{ paper: classes.paper }}
    >
      <DialogContent className={classes.root}>
        {isOpen ? <ReviewComponent /> : null}
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  isOpen: state.dashboard.reviewModal.isOpen,
});

const mapDispatchToProps = (dispatch) => ({
  resetModal: () => dispatch(actions.dashboard.reviewModal.reset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewModal);
